const translations = {
  searchOnMap: 'Buscar en el mapa',
  useCompleteSearch: 'Usar búsqueda completa',
  selectUsers: 'Selección de usuarios',
  'filters.creation': 'Creación'
}

export default translations
